// NPM imports
import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { NumberInput } from "@revvsales/components";

// Components Imports
import { checkAppFlag, numberForamting } from "../../../utils/globalUtils";

// Actions Imports
import { DealTableActions } from "../../../actions";

// Internal Imports
import { COMMON } from "../../../constants";

// Destructuring
const { APP_FLAGS, CURRENCY_SYMBOL, TABLE_TYPE, DEAL_LABELS } = COMMON;
const { onDealDiscountUpdate } = DealTableActions;

class DealTableFooter extends Component {
  state = {
    dealDiscount: 0,
    localUpdate: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      prevState.dealDiscount !== nextProps.discount.deal_discount &&
      !prevState.localUpdate
    ) {
      const dealDiscount = nextProps.discount.deal_discount;
      return { dealDiscount };
    }
    return null;
  }

  _updateOverallDiscount = value => {
    this.setState({
      dealDiscount: value || 0,
      localUpdate: true,
    });
  };

  _onBlurHandling = () => {
    this.setState({
      localUpdate: false,
    });
    this.props.onDealDiscountUpdate(
      this.state.dealDiscount,
      this.props.discount,
      this.props.dealTableId,
    );
  };

  render() {
    const {
      currency,
      discount: {
        dealTotal = 0,
        discountAmount = 0,
        discountedDealTotal = 0,
      } = {},
      isLocked,
      rowCount,
      tableType,
      dealValue,
    } = this.props;

    // Flags to display UI components based on Org setting
    const hideDealDiscount = checkAppFlag(APP_FLAGS.DEAL_DISCOUNT);

    // Based on the pricebook show the respective currency symbol
    const currencySymbol = CURRENCY_SYMBOL[currency];

    if (tableType === TABLE_TYPE.DEAL_TABLE) {
      return (
        <div className="dealtablefooter-wrapper">
          <div className="dealtablefooter-valuewrapper">
            <div className="dealtablefooter-row-count">
              {rowCount} {rowCount > 1 ? "items" : "item"}
            </div>
            <div className="dealtablefooter-grouptotal-section">
              <div className="dealtablefooter-split-wrapper">
                {hideDealDiscount ? (
                  <div className="grouptitlerenderer-grouptotal-split">
                    <div className="dealtablefooter-title">
                      <span>{DEAL_LABELS["deal-label"]} Total: </span>
                    </div>
                    <div className="dealtablefooter-values">
                      <span>{numberForamting(dealTotal, currencySymbol)}</span>
                    </div>
                  </div>
                ) : (
                  <Fragment>
                    <div className="grouptitlerenderer-grouptotal-split">
                      <div className="dealtablefooter-title">
                        <span>{DEAL_LABELS["deal-label"]} Discount (%)</span>
                        <span>
                          {" "}
                          {DEAL_LABELS["deal-label"]} Discount ({currencySymbol}
                          )
                        </span>
                      </div>
                      <div className="dealtablefooter-values">
                        <span className="dealtablefooter-discount-wrapper">
                          <NumberInput
                            data-test="dealtablefooter-discount-inp"
                            className="dealtablefooter-discount-inp"
                            disabled={isLocked}
                            isFloat
                            limitTo={100}
                            onBlur={this._onBlurHandling}
                            onChange={value =>
                              this._updateOverallDiscount(value)
                            }
                            placeholder="Discount"
                            value={this.state.dealDiscount}
                          />
                        </span>
                        <span>{numberForamting(discountAmount, "")}</span>
                      </div>
                    </div>
                    <div className="grouptitlerenderer-grouptotal-split">
                      <div className="dealtablefooter-title">
                        <span>Subtotal: </span>
                        <span className="dealtablefooter-values-final">
                          {DEAL_LABELS["deal-label"]} Total:{" "}
                        </span>
                      </div>
                      <div className="dealtablefooter-values">
                        <span>
                          {numberForamting(dealTotal, currencySymbol)}
                        </span>
                        <span
                          data-test="dealtablefooter-values-final"
                          className="dealtablefooter-values-final">
                          {numberForamting(discountedDealTotal, currencySymbol)}
                        </span>
                      </div>
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="dealtablefooter-wrapper">
        <div className="dealtablefooter-valuewrapper">
          <div className="dealtablefooter-row-count" />
          <div className="dealtablefooter-grouptotal-section">
            <div className="dealtablefooter-split-wrapper">
              <div className="grouptitlerenderer-grouptotal-split">
                <div className="dealtablefooter-title">
                  <span>{DEAL_LABELS["deal-label"]} Total: </span>
                </div>
                <div className="dealtablefooter-values">
                  <span>{numberForamting(dealValue, currencySymbol)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // ::QUOTATION STORE
  const { dealTableId, tableType } = state.QuotationStore;

  // ::DEALTABLE STORE
  const {
    discount: { [dealTableId]: discountObj = {} } = {},
    rowData: { [dealTableId]: rowData = [] } = [],
    priceBook: { [dealTableId]: priceBook = {} } = {},
  } = state.DealTableStore;

  // ::DOCUMENT STORE
  const {
    document: { isLocked = false, quoteTable = {} },
  } = state.DocumentStore;

  // ::ASSIGN REDUX KEYS TO RESPECTIVE DECLARED PROP VALUES
  const currency = (priceBook && priceBook.currency) || "USD";
  const dealValue = (quoteTable && quoteTable.amount) || 0;
  const discount = discountObj || {};
  const rowCount = (rowData && rowData.length) || 0;

  return {
    currency,
    dealTableId,
    dealValue,
    discount,
    isLocked,
    rowCount,
    tableType,
  };
};

const mapDispatchToProps = {
  onDealDiscountUpdate,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DealTableFooter);



// WEBPACK FOOTER //
// ./src/components/DealTable/DealTableFooter/index.js